var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.296,
    height: 22.105,
    viewBox: "0 0 34.296 22.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON",
    transform: "translate(0 -91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M23.176,91a11.063,11.063,0,0,0-3.016.417,11.095,11.095,0,0,0-6.029,0,11.052,11.052,0,1,0,0,21.27,11.1,11.1,0,0,0,6.029,0A11.062,11.062,0,1,0,23.176,91ZM2.01,102.052a9.076,9.076,0,1,1,9.11,9.043A9.087,9.087,0,0,1,2.01,102.052Zm20.162,0a11.047,11.047,0,0,0-4.7-9.036,9.042,9.042,0,0,1,0,18.072A11.047,11.047,0,0,0,22.172,102.052Zm1.333,9.036a11.042,11.042,0,0,0,0-18.073,9.04,9.04,0,0,1,0,18.073Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMotion);
export default __webpack_public_path__ + "static/media/icon-motion.7bbc183abb26e72e2268f224e1bcff64.svg";
export { ForwardRef as ReactComponent };